/* 🤖 this file was generated by svg-to-ts */
export const matIconBattery1Bar: {
  name: 'battery-1-bar';
  data: string;
} = {
  name: 'battery-1-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v12h6V6z"/></svg>`
};
